import React, {ChangeEvent, useEffect, useState} from "react";
import {Input} from "../../../ui-components/Input/Input";
import {ValidationErrorText} from "../../../ui-components/ValidationErrorText/ValidationErrorText";

import "./AchFirstNameInput.scss";

interface AchFirstNameInputProps {
    achFirstName: string;
    onSetAchFirstName: (firstName: string) => void;
    onSetIsAchFirstNameValid: (isFirstNameValid: boolean) => void;
}

export const AchFirstNameInput: React.FunctionComponent<AchFirstNameInputProps> = (props) => {
    const [errors, setErrors] = useState<string[]>([]);
    const [isValid, setIsValid] = useState<boolean>(true);
    const requiredAchFirstNameError = 'First Name is a required field.';

    useEffect(() => {
        props.onSetIsAchFirstNameValid(isValid);
    }, [isValid])

    const onChange = (event: ChangeEvent) => {
        let value = (event.target as HTMLInputElement).value;
        props.onSetAchFirstName(value);
        validateAchFirstName();
    }

    const onKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
        validateAchFirstName();
    }

    const validateAchFirstName = () => {
        let errorsTemp: string[] = [];
        if (props.achFirstName === '') {
            errorsTemp.push(requiredAchFirstNameError);
        }
        setErrors(errorsTemp);
        setIsValid(errorsTemp.length === 0);
    }

    return <div className="ach-first-name-container">
        <Input isValid={isValid} type='text' required={true} value={props.achFirstName} onChange={onChange}
               onKeyUp={onKeyUp}/>
        {errors.map((error: string) => {
            return <ValidationErrorText key={error} text={error}/>
        })}
    </div>
}
